/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * Helper function that attempts to stringify data. If stringify fails, it will
 * fallback to basic string serialization.
 */
export function safeStringify(input: unknown): string {
    let output: string;

    try {
        output = typeof input === 'object' ? JSON.stringify(input) : String(input);
    } catch (e) {
        if (e && e.name === 'TypeError') {
            // Fallback to string serialization
            output = String(input);
        } else {
            throw e;
        }
    }

    return output;
}
